import React, { FC } from 'react';
import { FieldOptionBase } from 'api/tasks';
import { Tag } from 'components/atoms/tag';

interface Props {
  option: FieldOptionBase;
}

export const SelectFieldOption: FC<Props> = ({ option: { color, label } }) =>
  color == null ? <>{label}</> : <Tag color={color}>{label}</Tag>;
